import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Home from "./page/Home";
import Contact from "./page/Contact";
import About from "./page/about";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Service from "./page/service";
import Testimonial from "./page/Testimonial";
import ScrollToTop from "./components/ScrollToTop";
import ResourcesPage from "./page/ResourcesPage";
import Approach from './page/Approach'
import IndustriesWeServe from "./page/IndustriesWeServe";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      {/* 👇 This ensures the page scrolls to top on every route change */}
      <ScrollToTop />

      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/solutions-services" element={<Service />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/ourapproach" element={<Approach/>}/>
        <Route path="/people-we-serve" element={<IndustriesWeServe />} />

      </Routes>

      <Footer />
      <ToastContainer position="bottom-right"  />
    </Router>
  );
}

export default App;
